import {
  select,
} from '@ngrx/store';
import {
  selectTravelerDetailsUIState,
  TravelerDetailsUIStore,
} from '@refx/shared-store';
import {
  Observable,
} from 'rxjs';
import {
  distinctUntilChanged,
  filter,
  map,
} from 'rxjs/operators';

/**
 * Country of residence for billing address
 */
export const countryOfResidence = () => (source: Observable<TravelerDetailsUIStore>) =>
  source.pipe(
    filter((store) => !!store.travelerDetailsUI),
    select(selectTravelerDetailsUIState),
    map((travelerDetails) => travelerDetails?.countryOfResidenceForBillingAdd),
    distinctUntilChanged()
  );
